module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('block-number-field', {
    attrs: {
      "error": _vm.$attrs.errors.block.number
    },
    model: {
      value: (_vm.$attrs.block.number),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.block, "number", $$v)
      },
      expression: "$attrs.block.number"
    }
  }), _vm._v(" "), _c('building-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.formType == 'add' && _vm.$attrs.block.building)),
      expression: "!(formType == 'add' && $attrs.block.building)"
    }],
    attrs: {
      "error": _vm.$attrs.errors.block.building
    },
    model: {
      value: (_vm.$attrs.block.building),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.block, "building", $$v)
      },
      expression: "$attrs.block.building"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e144e5e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/block/BlockBlankForm.vue
// module id = 718
// module chunks = 0